import React, { useEffect, useState } from 'react';
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const SectorList = () => {
  const [sectores, setSectores] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/sectores/').then(res => setSectores(res.data));
  }, []);

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Sectores</Typography>
        <Button variant="contained" onClick={() => navigate('/sectores/nuevo')}>Nuevo Sector</Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Activo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sectores.map(sec => (
              <TableRow key={sec.id_sector}>
                <TableCell>{sec.codigo}</TableCell>
                <TableCell>{sec.descripcion}</TableCell>
                <TableCell>{sec.activo ? 'Sí' : 'No'}</TableCell>
                <TableCell>
                  <Button size="small" variant="outlined" onClick={() => navigate(`/sectores/${sec.id_sector}`)}>
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default SectorList;